import { ActionRequiredAlertServiceImpl } from "./action-required-alert-service";
import { InformativeAlertService } from "./informative-alert-service";
import { LegacyActionRequiredAlertService } from "./legacy-action-required-alert-service";
import { AudioServiceImplementation } from "./audio-service";
import { bindHtmlCompileDirective } from "./bind-html-compile";
import { chainParentFocusDirective } from "./chain-parent-focus";
import { deprecationDirective } from "./deprecationDirective";
import { fillBiAreaDirective } from "./fill-bi-area";
import { fillBiSlotDirective } from "./fill-bi-slot";
import { pageActionTriggerDirective } from "./page-action-trigger";
import { logViewComponentOptions } from "./LogView";
import { stickyDirective } from "./sticky";
import { actionRequiredNotificationComponentOptions } from "./action-required-notification";
import directiveModule from "./sdDirectiveModule";

directiveModule
  .component("logView", logViewComponentOptions)
  .component("actionRequiredNotification", actionRequiredNotificationComponentOptions)
  .service("actionRequiredAlertService", ActionRequiredAlertServiceImpl)
  .service("informativeAlertService", InformativeAlertService)
  .service("legacyActionRequiredAlertService", LegacyActionRequiredAlertService)
  .service("audioService", AudioServiceImplementation)
  .directive("sdBindHtmlCompile", bindHtmlCompileDirective)
  .directive("sdChainParentFocus", chainParentFocusDirective)
  .directive("sdDeprecation", deprecationDirective)
  .directive("sdFillBiArea", fillBiAreaDirective)
  .directive("sdFillBiSlot", fillBiSlotDirective)
  .directive("sdPageActionTrigger", pageActionTriggerDirective)
  .directive("sdSticky", stickyDirective);
